export default {
  primaryBlue: "#0e7adc",
  primaryGreen: "#26C6AF",
  lightGreen: "#1FD4BA",
  primaryBlack: "#161616",
  primaryGrey: "#757575",
  secondaryGrey: "#535353",
  white: "#ffffff",
}



// WEBPACK FOOTER //
// ./src/theme/colors.ts